import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CountryItem } from 'src/components/country-bar/types';
import { deriveCountryCode } from 'src/components/visibility/hooks/countryCode';
import { useRegionsQuery } from 'src/context/api/non-branded/api';
import { RegionDataPoint } from 'src/context/api/non-branded/models';
import { useCurrentWorkspace } from 'src/context/reducers/app-settings';
import { fDate } from 'src/utils/format-time';

/** Country tabs of the Non Brand Cluster Manager, by descending share of Non Brand clicks. */
export const regionsToCountryItems = (regions: RegionDataPoint[]): CountryItem[] =>
  [...regions]
    .sort((a, b) => (b.perc_clicks ?? 0) - (a.perc_clicks ?? 0))
    .map((region) => ({
      country_name: region.region_name,
      country_code: deriveCountryCode(region.region_name),
      share_of_brand_searches: null,
    }));

/** Regions with Non Brand traffic over the current date range (same source as the Overview's region bar). */
export function useNonBrandCountries(enabled: boolean): { countries: CountryItem[]; isLoading: boolean } {
  const workspace = useCurrentWorkspace();
  const filterStore = useSelector((state: any) => state.filters);
  const { data, isFetching } = useRegionsQuery(
    {
      workspace_id: workspace?.id as number,
      start_date: fDate(filterStore.start, 'yyyy-MM-dd'),
      end_date: fDate(filterStore.end, 'yyyy-MM-dd'),
      devices: filterStore.devices,
      countries: [],
      platforms: filterStore.platforms,
      search_terms: [],
    },
    { skip: !enabled || !workspace?.id || !filterStore.start || !filterStore.end }
  );
  const countries = useMemo(() => regionsToCountryItems(data?.data ?? []), [data]);
  return { countries, isLoading: isFetching };
}
